$(function () {
    let section = $('#seccionPagos')
    if (section.get(0) == null) {
        return
    }
    let vueApp = new Vue({
        el: section.get(0),
        data: {
            loader: false,
            filtros: { page: 1, buscar: null, forma_pago: null, cliente_id: null, sitio_id: null,
                fecha_inicio: null, fecha_fin: null},
            pagos: [],
            modalTitulo: 'Nuevo pago',
            sitios: [],
            clientes: [],
            clientesSitios: [],
            sitio: {},
            pago: {},
            link: {},

            precio: 0,
            escalasTimbres: [],
        },
        mounted() {
            this.escalasTimbres = Object.assign([], escalasTimbresJSON)
            this.minTimbres = escalasTimbresJSON[0].min
            this.maxTimbres = escalasTimbresJSON[escalasTimbresJSON.length - 1].max

            this.initDatePicker()
            this.clientes = clientesJson;
            this.sitios = sitiosJson
            this.getPagos()
        },
        methods: {
            getPagos(pagina = null) {
                if (this.loader) {
                    return
                }
                if (pagina != null) {
                    this.filtros.page = pagina
                }
                this.loader = true
                axios
                    .get('/admin/pagos/json', {
                        params: this.filtros,
                    })
                    .then((response) => {
                        vueApp.loader = false
                        if (response.data.error) {
                            swal({
                                icon: "info",
                                title: response.data.error,
                                button: {
                                    text: "Aceptar",
                                    closeModal: true,
                                },
                            })
                            return
                        }
                        vueApp.pagos = response.data.pagos.data;
                        vueApp.filtros.total = response.data.pagos.total;
                        vueApp.filtros.per_page = response.data.pagos.per_page;
                        vueApp.filtros.from = response.data.pagos.from;
                        vueApp.filtros.to = response.data.pagos.to;
                    })
                    .catch((error) => {
                        vueApp.loader = false
                        swal({
                            icon: "info",
                            title: "Ocurrió un error inesperado",
                            button: {
                                text: "Aceptar",
                                closeModal: true,
                            },
                        })
                    })
            },
            eliminar(id) {
                swal({
                    title: '¿Eliminar registro?',
                    icon: 'warning',
                    buttons: { cancel: 'Cancelar', ok: 'Aceptar', },
                    dangerMode: true,
                }).then((ok) => {
                    if (ok) {
                        axios
                            .delete('/admin/pagos/' + id)
                            .then(function (response) {
                                if (response.data.error) {
                                    swal({
                                        icon: "info",
                                        title: response.data.error,
                                        button: {
                                            text: "Aceptar",
                                            closeModal: true,
                                        },
                                    })
                                    return
                                }
                                vueApp.getPagos(1)
                            })
                            .catch((error) => {
                                swal({
                                    icon: "info",
                                    title: "Ocurrió un error inesperado",
                                    button: {
                                        text: "Aceptar",
                                        closeModal: true,
                                    },
                                })
                            })
                    }
                })
            },
            actualizarProducto(){
                this.pago.cantidad = 1;
                this.$nextTick(() => {
                    vueApp.validar()
                })
                this.checkCantidad()
            },
            checkCantidad(){
                if(this.pago.cantidad <= 0){
                    this.pago.cantidad = 1
                }
                this.calcularTotal()
            },
            filtrarSitios(){
                this.clientesSitios = [];
                let id = this.pago.cliente_id;
                let cliente = this.clientes.find(item => item.id == id)
                if(cliente != null){
                    this.clientesSitios = cliente.sitios;
                }
            },
            filtrarSitiosLink(){
                this.clientesSitios = [];
                let id = this.link.cliente_id;
                let cliente = this.clientes.find(item => item.id == id)
                if(cliente != null){
                    this.clientesSitios = cliente.sitios;
                }
            },
            buscarSitio(){
                let index = this.sitios.findIndex(item => this.pago.sitio_id == item.id)
                if(index > -1){
                    this.sitio = this.sitios[index]
                }
                else{
                    this.sitio = {}
                }
                this.$nextTick(() => {
                    vueApp.validar()
                })
                this.calcularTotal()
            },

            calcularTotal(){
                let cantidad = parseInt(this.pago.cantidad)
                if(isNaN(cantidad) || cantidad < 1){
                    cantidad = 1
                }
                let precio = 0;
                if(this.pago.tipo == "timbres"){
                    let escala = null
                    for(let i = 0; i < this.escalasTimbres.length; ++i){
                        let escalaEx = this.escalasTimbres[i]
                        if(escalaEx.min <= cantidad && escalaEx.max >= cantidad){
                            escala = escalaEx;
                            break
                        }
                    }
                    if(escala == null){
                        escala = this.escalasTimbres[0]
                    }
                    precio = escala.precio
                }
                else if(this.pago.tipo == "anual" || this.pago.tipo == "mensual"){
                    precio = parseFloat(this.sitio.suscripcion_precio)
                }
                if(isNaN(precio)){
                    precio = 0
                }
                this.pago.total = precio * cantidad
            },
            generarLink(){
                $('#formLink')[0].reset()
                this.link = Object.assign({}, {
                    cliente_id: null,
                    sitio_id: null,
                    concepto: null,
                    importe: null
                })
                this.modalTitulo = 'Nuevo link de pago'
                $('#modalLink').modal('show')
                this.$nextTick(() => {
                    vueApp.validarLink()
                })
            },
            validarLink() {
                $('#formLink').validarForm((form) => {
                    let params = new URLSearchParams();
                    params.set("concepto", vueApp.link.concepto);
                    params.set("importe", vueApp.link.importe);

                    let url = "/pagar/personalizado/" + vueApp.link.cliente_id
                    if(vueApp.link.sitio_id != null){
                        url += "/" + vueApp.link.sitio_id
                    }
                    window.open(url + "?" + params.toString());
                    $('#modalLink').modal('hide')
                })
            },
            agregar() {
                this.clientesSitios = [];
                $('#formPago')[0].reset()
                this.pago = Object.assign({}, {cliente_id: null, sitio_id: null, forma_pago: null, tipo: null, cantidad: 1, total: null})
                this.modalTitulo = 'Nuevo pago'
                $('#modalPago').modal('show')
                this.validar()
            },
            validar() {
                $('#formPago').validarForm((form) => {
                    vueApp.guardar(form)
                })
            },
            guardar(form) {
                $('#btnGuardar').loader('show')
                let formData = new FormData(form)
                axios
                    .post('/admin/pagos/guardar', formData)
                    .then((respuesta) => {
                        $('#btnGuardar').loader('hide')
                        if (respuesta.data.error) {
                            swal({
                                icon: "info",
                                title: respuesta.data.error,
                                button: {
                                    text: "Aceptar",
                                    closeModal: true,
                                },
                            })
                            return
                        }
                        $('#modalPago').modal('hide')
                        vueApp.getPagos(1)
                    })
                    .catch((error) => {
                        console.log(error)
                        $('#btnGuardar').loader('hide')
                        swal({
                            icon: "info",
                            title: "Ocurrió un error inesperado",
                            button: {
                                text: "Aceptar",
                                closeModal: true,
                            },
                        })
                    })
            },
            initDatePicker() {
                $('.fc-datepicker').datepicker({
                    showOtherMonths: true,
                    selectOtherMonths: true,
                    autoclose: true,
                    format: 'dd/mm/yyyy',
                    language: 'es',
                })
                $('#fechaInicio')
                    .datepicker()
                    .on('changeDate', function (ev) {
                        let fecha = $(ev.target).val()
                        if (fecha != null) {
                            fecha = fecha.split('/')
                            fecha = [fecha[2], fecha[1], fecha[0]].join('-')
                        }
                        vueApp.filtros.fecha_inicio = fecha
                        vueApp.getPagos(1)
                    })
                $('#fechaFin')
                    .datepicker()
                    .on('changeDate', function (ev) {
                        let fecha = $(ev.target).val()
                        if (fecha != null) {
                            fecha = fecha.split('/')
                            fecha = [fecha[2], fecha[1], fecha[0]].join('-')
                        }
                        vueApp.filtros.fecha_fin = fecha
                        vueApp.getPagos(1)
                    })
            },
        },
    })

    function MonedaFiltro (value) {
        if (value === null || value === undefined || isNaN(value)) {
            return '$0.00'
        }
        if (typeof value !== 'number') {
            value = parseFloat(value)
        }
        var formatter = new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            maximumFractionDigits: 2,
        })
        let moneda = formatter.format(value);
        let monedaArr = moneda.split(".");
        if(parseFloat(monedaArr[1]) > 0){
            return moneda
        }
        return monedaArr[0];
    }
})
